import Modal from 'views/components/UI/Modal'
import { H3, H5 } from 'views/components/UI/Text'
import { BackButton, Button } from 'views/components/UI/Buttons'
import { ButtonsContainer, ModalContent, ModalHeader, TrashIconBig } from './styled'

import IconBigX from 'assets/images/big-x.png'

export interface ModalQuestionsProps {
  showModal: boolean
  handleClose: () => void
  handleCloseEvaluation: () => void
}

const ModalCloseEvaluation: React.FC<ModalQuestionsProps> = ({ showModal, handleClose, handleCloseEvaluation }) => {
  const handleSend = () => {
    handleCloseEvaluation()
  }

  return (
    <Modal
      show={showModal}
      setShow={handleClose}
      hideCloseButton
      styleContent={{
        maxWidth: '40vw',
        minWidth: '700px',
        maxHeight: 'auto',
        padding: '20px',
        margin: '0',
      }}
    >
      <ModalContent style={{ alignItems: 'center' }}>
        <ModalHeader style={{ alignItems: 'center', justifyContent: 'center' }}>
          <TrashIconBig src={IconBigX} alt="X icon" />
          <H3 style={{ textAlign: 'center' }}>¿Seguro que deseas cerrar esta evaluación?</H3>
          <H5 style={{ fontWeight: '400', textAlign: 'center' }}>
            Una vez cierres la evaluación el evaluador no podrá acceder a ella y sus respuestas no serán tenidas en
            cuenta en el resultado consolidado.
          </H5>
        </ModalHeader>
        <ButtonsContainer>
          <BackButton text="Volver" hideIcon onClick={handleClose} />
          <Button
            onClick={handleSend}
            type="button"
            style={{ width: 'fit-content', display: 'flex', alignItems: 'center' }}
          >
            Cerrar evaluación
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </Modal>
  )
}

export default ModalCloseEvaluation
